export default "__VITE_ASSET__Dc37RgXg__"